export default __webpack_public_path__ + "static/43-fit-46019eaf1290a49fde5b82dc5a6e4d67.png";